import React from 'react';
import { Button as BSButton } from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';

import Accordion from 'components/Accordion';
import { useClosure } from 'utils/hooks';
import useObservedDataControlPanel from 'utils/hooks/meteorology/useObservedDataControlPanel';
import { ObservedDataPeriodMode } from 'types/Meteorology/Fields/ObservedData/getOptions';
import VisualizationSelector from 'components/Meteorology/Fields/ControlPanel/VisualizationSelector';

import './index.scss';

export default function ObservedData() {
  const {
    RegionSelectorOD,
    VariableSelector,
    getSelector,
    setMode,
    mode,
    queryTrigger,
    areParamsSelected,
    availableTabs,
    viewMode,
    setViewMode,
    isHeatmapDisabled,
  } = useObservedDataControlPanel();
  const setPresetMode = useClosure(setMode, 'preset');
  const setDateMode = useClosure(setMode, 'date');
  const setFreeMode = useClosure(setMode, 'free');
  const modeSelectorClassName = (modeName: ObservedDataPeriodMode) => (
    mode === modeName ? 'mode-selector-current' : 'mode-selector'
  );
  const modeDisplayClassName = (tab: ObservedDataPeriodMode) => (
    availableTabs.includes(tab) ? '' : 'd-none'
  );

  return (
    <div>
      <Accordion>
        <Accordion.Item eventKey="1">
          <Accordion.Header>Variável</Accordion.Header>
          <Accordion.Body className="d-grid">
            <VariableSelector />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>Visualização</Accordion.Header>
          <Accordion.Body className="d-grid">
            <VisualizationSelector
              value={viewMode}
              onChange={setViewMode}
              options={[
                { value: 'heatmap', label: 'Heatmap', disabled: isHeatmapDisabled },
                { value: 'spatial', label: 'Espacial' },
              ]}
            />
          </Accordion.Body>
        </Accordion.Item>
        {viewMode === 'spatial' && (
          <Accordion.Item eventKey="3">
            <Accordion.Header>Área de plotagem</Accordion.Header>
            <Accordion.Body className="d-grid">
              <RegionSelectorOD />
            </Accordion.Body>
          </Accordion.Item>
        )}
        <Accordion.Item eventKey="4">
          <Accordion.Header>Período de seleção</Accordion.Header>
          <Accordion.Body>
            {viewMode === 'spatial' && (
              <div className={`mode-switcher justify-content-center ${availableTabs.length === 0 ? 'd-none' : ''}`}>
                <div className={`${modeSelectorClassName('preset')} ${modeDisplayClassName('preset')}`}>
                  <BSButton variant="link" className="button-link" onClick={setPresetMode}>
                    Pré-definido
                  </BSButton>
                </div>
                <div className={`${modeSelectorClassName('date')} ${modeDisplayClassName('date')}`}>
                  <BSButton variant="link" className="button-link" onClick={setDateMode}>
                    Data
                  </BSButton>
                </div>
                <div className={`${modeSelectorClassName('free')} ${modeDisplayClassName('free')}`}>
                  <BSButton variant="link" className="button-link" onClick={setFreeMode}>
                    Livre
                  </BSButton>
                </div>
              </div>
            )}
            {getSelector()}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <Button
        className="w-100 mt-5"
        onClick={queryTrigger}
        disabled={!areParamsSelected}
      >
        Realizar consulta
      </Button>
    </div>
  );
}
